import { useMemo, type PropsWithChildren } from 'react';
import { Icon } from '../Icon';
import { useProgressSteps } from './ProgressSteps';
import clsx from 'clsx';

type ProgressStepProps = PropsWithChildren<{
  value: string;
}>;

export const ProgressStep = ( { children, value }: ProgressStepProps ) => {
  const progressSteps = useProgressSteps();

  const state = useMemo( () => {
    if ( value === progressSteps.value ) {
      return 'active';
    }

    const currentValueIndex = progressSteps.values.indexOf( progressSteps.value );
    const stepValue = progressSteps.values.indexOf( value );

    return stepValue < currentValueIndex ? 'completed' : 'queued'
  }, [ value, progressSteps.value, progressSteps.values ] );

  return (
    <div className={ 'flex flex-col gap-1.5 items-center relative' }>
      <div className={ clsx(
        'w-5 h-5 rounded-full border flex items-center justify-center',
        {
          'border-[#00B67A]': state === 'completed',
          'border-[#673AFD]': state !== 'completed',
          'bg-[#673AFD]': state === 'active'
        }
      ) }>
        { state === 'completed' && (
          <Icon
            name={ 'check' }
            className={ 'text-[#00B67A] text-sm' }
          />
        )}
      </div>
      <span className={ 'text-xs font-onest absolute -bottom-5' }>{ children }</span>
    </div>
  )
}
ProgressStep.displayName = 'ProgressStep';
